// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReservationOption_wrapper__3bo3n","icon":"ReservationOption_icon__2mAoj","content":"ReservationOption_content__zGmvB"};